import api from "../../../../services/api";
import store from "../../../../store";

import type from "./types";
import {
  DocumentTypeFieldsToPost,
  DocumentTypeToPost,
  DocumentTypesToGet,
  DocumentTypesToGet_documentTypeFields,
} from "../../models/interfaces";
import { ActionType } from "../../../../models/types";

const baseUrl = process.env.REACT_APP_PROVIDERDOCUMENT;

export const setSelectedDocumentType = async (params: Object) => {
  try {
    store.dispatch(setSelectedDocumentTypeStore(params));
    return true;
  } catch (err) {
    return false;
  }
};

const setSelectedDocumentTypeStore = (data: any): ActionType => ({
  type: type.SET_SELECTED_DOCUMENT_TYPE,
  payload: data,
});

const setDocumentTypes = (data: any): ActionType => ({
  type: type.SET_LIST_DOCUMENTS_TYPES,
  payload: data,
});

const setLoading = (data: boolean): ActionType => ({
  type: type.SET_LOADING_DOCUMENT_TYPES,
  payload: data,
});

export const createDocumentType = async (params: DocumentTypeFieldsToPost) => {
  try {
    await api.post(baseUrl + "/documentTypes", params);
    return true;
  } catch (err) {
    return false;
  }
};

export const editDocumentTypeFields = async (
  params: DocumentTypeFieldsToPost
) => {
  try {
    await api.put(baseUrl + "/documentTypes", params);
    return true;
  } catch (err) {
    return false;
  }
};

export const editDocumentType = async (params: DocumentTypeToPost) => {
  try {
    await api.put(baseUrl + "/documentTypes/", params);
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const deleteDocumentType = async (documentTypeId: number) => {
  try {
    await api.delete(baseUrl + `/documentTypes/${documentTypeId}`);
    const listDocumentTypes: DocumentTypesToGet[] = store.getState()
      .DocumentType.listDocumentTypes;
    store.dispatch(
      setDocumentTypes(
        listDocumentTypes.filter((object) => object.id !== documentTypeId)
      )
    );
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getDocumentsTypes = async () => {
  store.dispatch(setLoading(true));
  try {
    const { data } = await api.get(baseUrl + "/documentTypes");
    let res: DocumentTypesToGet[] = data.data.documentTypes;
    res = res.filter((object) => object.active !== false);

    if (res && res.length > 0) {
      store.dispatch(setDocumentTypes(res));
    }
  } catch (err) {
    console.log(err);
  } finally {
    store.dispatch(setLoading(false));
  }
};

export const getDocumentTypeById = async (id: number) => {
  try {
    const { data }: any = await api.get(baseUrl + `/documentTypes/${id}`);
    let documentTypeFields: DocumentTypesToGet_documentTypeFields[] =
      data.data.documentType.documentTypeFields;
    documentTypeFields = documentTypeFields.filter(
      (object) => object.active !== false
    );
    data.data.documentType.documentTypeFields = documentTypeFields;
    return data;
  } catch (err) {
    console.log(err);
  }
};
